<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
        <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
            <b-col>
                <h1>{{ecmResourceStrings.ttlSMTPNotifications}}</h1>
            </b-col>
            <b-col class="text-right OTbtnContainer" cols="4">
                <otif-button class="OTSecondary"  @click.native="back" id="backtoexec" :title="ecmResourceStrings.tipBackToECM" style="margin-right:0.5rem" >{{ecmResourceStrings.lblBack}}</otif-button>
                <b-dropdown text="Actions" right class="OTtableRowDropdown">
                    <b-dropdown-item v-for="action in globalActions" @click="onGlobalAction(action)" :key="action.name">
                        <span :class="'ot-icon-' + action.id" />{{ action.label }}
                    </b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>

         <b-row>
            <b-col>
                <SettingsTable
                :rows="repoList"
                :columns="columns"
                :actions="actions"
                :customOptions="customOptions"
                >
            </SettingsTable>
            </b-col>
        </b-row>
    </b-col>
</b-row>
</template>

<script>

import axios from 'axios';
import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';
import ProvideCredo from '../../modals/ECMCrawlerPassword.vue';
import SettingsTable from '@/ecm/components/ECMSettingsTable.vue';
import ecmRepositories from '@/ecm/collections/ecmrepositories.js';
import { required } from 'vuelidate/lib/validators';
import { repoid } from '../../../utils/validatorECM.js';
import { duplication } from '../../../utils/validatorECM.js';
import ErrorColumn from '../../links/ecmimporterror.vue';
import StatusColumn from '../../links/dashboardstatus.vue';

export default {
    components: {
         ECMErrorDialog,
         SettingsTable,
     },

    data() {
        return {
            
            loaded: false,
            repoList : [], 
            ecmRepositories: new ecmRepositories({paginated: false }),
            ecmResourceStrings: require('../../../utils/resourceECM.js'),
            customOptions:  [],
            columns: [
           {
                name: 'repositoryId',
                label: 'ID',
                sortable: false,
                editable:true,
                checkable:false,
                width:'9%',
                render(row) {
                    return row.repositoryId;
                }
            },{
                name: 'repositoryType',
                label: 'Connector',
                sortable: false,
                editable:false,
                checkable:false,
                width:'15%',
                render(row) {
                    return row.repositoryType;
                }
            },{
                name: 'description',
                label: 'Description',
                sortable: false,
                editable:true,
                checkable:false,
                width:'30%',
                render(row) {
                    return row.description;
                }
            },{
                name: 'status',
                label: 'Status',
                sortable: false,
                checkable:false,
                editable:false,
                width:'5%',
                displayComponent:StatusColumn,
            },{
                name: 'statusdescription',
                sortable: false,
                editable:false,
                checkable:false,
                width:'15%',
                render(row) {
                    return row.statusdescription;
                }
            }],
            actions: [{
                    name: 'start',
                    label: 'Start Notifications',
                    callback: (row) => { this.start(row); }
                },{
                    name: 'stop',
                    label: 'Stop Notifications',
                    callback: (row) => { this.stop(row); }
                }],
                globalActions: [{
                    name: 'startall',
                    label: 'Start',
                    callback: () => { this.allStart(); }
                },{
                    name: 'stopAll',
                    label: 'Stop',
                    callback: () => { this.allStop();}
                }
            ],
        }
    },

    methods: {

        onGlobalAction(action) {
            if (action['callback']) {
                action.callback(action);
            }
        },

        back(){
            this.$router.push('/settings/ecmrepositories');
        },
       
        async stop(rowNumber)
        {
            var that = this;
            if(that.repoList[rowNumber])
            {
                var onerepo = that.repoList[rowNumber];
                if(onerepo)
                {
                    const ecmRepositoryID = onerepo.repositoryId;
                    onerepo.status = "Working";
                    onerepo.statusdescription ="Working";
                    
                    const connString=that.createBodyPostString("StopMonitorErrorLog", ecmRepositoryID);

                    const res = await axios.post('/mtm-gateway-api/v1/services/ecm/actions/CrawlerExecuteProcess', connString, 
                        {headers: {"Content-Type": "application/json; charset=UTF-8"}})
                    .then((res) => {
                        if (res.data && res.data.crawlerOperationDetails[0])
                        {
                            that.getStatus(rowNumber, ecmRepositoryID); 
                        }
                    })
                   .catch((err) => {
                        onerepo.status = "CommunicationError";
                        if(err.response)
                            {
                                onerepo.statusdescription =err.response.statusText;
                            }
                            else if (err.message)
                            {
                                onerepo.statusdescription =err.message;
                            }
                            else
                            {
                                onerepo.statusdescription ="Undefined error"
                            }
                    });      
                }
            }
        },

        start(rowNumber)
        {
            var that = this;
            if(that.repoList[rowNumber])
            {
                var onerepo = that.repoList[rowNumber];
                if(onerepo)
                {
                    const ecmRepositoryID = onerepo.repositoryId;
                    onerepo.status = "Working";
                    onerepo.statusdescription ="Working";
                    
                    const connString=that.createBodyPostString("MonitorErrorLog", ecmRepositoryID);

                    axios.post('/mtm-gateway-api/v1/services/ecm/actions/CrawlerExecuteProcess', connString, 
                        {headers: {"Content-Type": "application/json; charset=UTF-8"}})
                    .then((res) => {
                        if (res.data && res.data.crawlerOperationDetails[0])
                        {
                            that.getStatus(rowNumber, ecmRepositoryID); 
                        }
                    })
                   .catch((err) => {
                        onerepo.status = "CommunicationError";
                        if(err.response)
                            {
                                onerepo.statusdescription =err.response.statusText;
                            }
                            else if (err.message)
                            {
                                onerepo.statusdescription =err.message;
                            }
                            else
                            {
                                onerepo.statusdescription ="Undefined error"
                            }
                    });      
                }
            }
        },

        allStop()
        {
            var that = this;
            if(that.repoList)
            {
                var i = 0;

                for(i=0;i<that.repoList.length;i++)
                {
                    const onerepo = that.repoList[i];
                    if(onerepo)
                    {
                        if(onerepo.status == 'Running')
                            that.stop(i);
                    }
                }
            }
        },

        allStart()
        {
            var that = this;
            if(that.repoList)
            {
                var i = 0;

                for(i=0;i<that.repoList.length;i++)
                {
                    const onerepo = that.repoList[i];
                    if(onerepo)
                    {
                        if(onerepo.status == 'NotRunning')
                            that.start(i);
                    }
                }
            }
        },

        createBodyPostString(name, id)
        {
            const parameters = '[{ "name" : "shRepositoryId", "value" : '+ id +', "type" : "int","isNull" : false}]';
            const configstring = '{"name": "' + name + '", "engineName": "1", "parameters": ' + parameters + ', "asynchronousExecution": true}';
            return configstring;
        },

        async getStatus(listitem, ecmrepositoryid) {
            /*OTIC Look up table ManageErrorMonitoring contains status for monitoring repositories
            Field from the table ISRun: 0 - Monitoring for the repository is not running , 1 - Monitoring is running  
            If record in the table is missing – Monitoring is not running.*/
            var that = this;
            that.repoList[listitem].status ="Working";
            that.repoList[listitem].statusdescription ="Working";

                const res = await axios.get('/mtm-gateway-api/v1/services/ecm/query/manageErrorMonitoring/' +ecmrepositoryid)
                 .then((res) => {
                if(res)
                {
                    
                    if(res.status == 200) //OK
                    {
                        if(res.data && res.data.db_records)
                        {
                            const len = res.data.db_records.length;
                            if(len > 0)
                            {
                                const iter = len - 1;
                                for(var i =iter; i > -1; i--)
                                {
                                    const oneArray = res.data.db_records[iter];
                                    if(oneArray)
                                    {
                                        if(oneArray.db_fields && oneArray.db_fields.length == 3)//there is 3 columns in lookup table
                                        {
                                            const ecmdata = oneArray.db_fields[0].db_field_properties;
                                            const stopdata = oneArray.db_fields[1].db_field_properties;
                                            const rundata = oneArray.db_fields[2].db_field_properties;
                                            if(ecmdata && stopdata && rundata)
                                            {
                                                if(ecmdata.value == ecmrepositoryid)
                                                {
                                                    const stopFlag = stopdata.value;
                                                    const runningFlag = rundata.value;
                                                    if(runningFlag == 0)
                                                    {//ISRun: 0 - Monitoring for the repository is not running
                                                        that.repoList[listitem].status ="NotRunning";
                                                        that.repoList[listitem].statusdescription ="Not Running";
                                                    }
                                                    else if(runningFlag == 1)
                                                    {// 1 - Monitoring is running
                                                        if(stopFlag == 0)
                                                        {
                                                            that.repoList[listitem].status ="Running";
                                                            that.repoList[listitem].statusdescription ="Running";
                                                        }
                                                        else
                                                        {//still running but flag stop is already on
                                                            that.repoList[listitem].status ="NotRunning";
                                                            that.repoList[listitem].statusdescription ="Not Running";
                                                        }
                                                    }
                                                    break;
                                                }
                                                else
                                                {
                                                    continue;
                                                }
                                            }
                                            else
                                            {
                                                that.repoList[listitem].status ="Error";
                                                that.repoList[listitem].statusdescription ="Corrupted data";
                                            }
                                        }
                                        else
                                        {
                                            that.repoList[listitem].status ="Error";
                                            that.repoList[listitem].statusdescription ="Invalid data";
                                        }
                                    }
                                    else
                                    {
                                        that.repoList[listitem].status ="CommunicationError";
                                        that.repoList[listitem].statusdescription ="Can not get status";
                                    }
                                }
                            }
                            else
                            {
                                that.repoList[listitem].status ="NotRunning";
                                that.repoList[listitem].statusdescription ="Not Running";
                            }
                        }
                        else
                        {
                            that.repoList[listitem].status ="NotRunning";
                            that.repoList[listitem].statusdescription ="Not Running";
                        }
                    }
                    else
                    {
                        that.repoList[listitem].status ="Error";
                        that.repoList[listitem].statusdescription ="Error";
                    }
                }
            })
            .catch((err) => {
                //can not get status at all
                const d = new Date();
                that.repoList[listitem].timestamp="on " + d;
                that.repoList[listitem].status ="CommunicationError";
                if(err.response)
                {that.repoList[listitem].statusdescription =err.response.statusText;
                }
                else{
                    if(err.message)
                    {
                    that.repoList[listitem].statusdescription=err.message;
                    }
                    else{
                        that.repoList[listitem].statusdescription="Unknown error";
                    }
                }
            });
        }
    },


    mounted() {
         var breadcrumbs = [{
            name: 'settings',
            meta: { label: 'Settings' }
        },{
            name: 'ecm-repositories',
            meta: { label: 'Repositories' }
        },{
            name: 'ecm-repositories-smtp-overview',
            meta: { label: 'Overview SMTP Notifications' }
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
    },

    created() {
        var that = this;
        Promise.all([
                that.ecmRepositories.fetch( {"Content-Type": "application/json; charset=UTF-8"}),
            ]).then(() => {
                const colOfEcmRepositories =  that.ecmRepositories.resources;
                if(colOfEcmRepositories)
                {
                    const lenx = colOfEcmRepositories.length;
                    for(var j=0; j<lenx; j++)
                    {
                        const onerepo = colOfEcmRepositories[j];
                        if(onerepo)
                        {
                            const id = onerepo.attributes['repositoryId'];
                            const type = onerepo.attributes['repositoryType'];
                            const description = onerepo.attributes['description'];
                            if(type != 'dbms_generic_v1')
                            {
                                that.repoList.push({ repositoryId: id, repositoryType: type, description : description, status: '', statusdescription :''});
                                const listitem = that.repoList.length - 1;
                                that.getStatus(listitem, id);
                            }
                        }
                    }
                }
                that.loaded = true;
            })
            .catch((err) => {
                console.log(err);
                that.loaded = true;
            });

    },

}
</script>